<template>
    <div class="tops_body">
      <div class="tops_body__header">
            <span class='fullName'>{{ fullName }}</span>
            <div class="btnWrap" v-if="loginState == false">
                <button v-if="loginState == false" class='mypage-reserve-update-button' v-on:click='onLogin'>ログイン</button>
                <button v-if="loginState == false" class='mypage-reserve-update-button' v-on:click='onSignup'>新規会員登録</button>
            </div>
            <button v-else class='mypage-reserve-update-button' v-on:click='onLogout'>ログアウト</button>
      </div>
      <div class="header_container">
          <div v-if="existImg == true" class="text-center">
              <img :src="imgPath" class='golf_course_img'/>
          </div>
      </div>
      <div class="start-time-body">
        <h3 class='golf-name-title'>
            <span>{{ playDate }}</span>
            <span class="d-block d-sm-inline-block">{{ planName }}</span>
        </h3>
        <div class="pt-5">
          <h4 class='font-weight-bold bg-single'>リクエスト内容入力</h4>
          <div class='py-2'>
            <span class="mr-5 bg-single">ご希望の内容をご入力ください。</span>
            <span class="text-danger d-block d-sm-inline-block">
              ※同じプレー日での複数予約、リクエストはできません。
            </span>
          </div>
          <div class='table-back-ground pcview'>
            <table class="request-table-body">
              <tr>
                <td colspan="2" >
                  プレー日
                </td>
                <td class="border-right-0">
                  {{ playDate }}
                </td>
                <td class="border-left-0"/>
              </tr>
              <tr>
                <td rowspan="3" class="width-210">
                  スタート時間
                </td>
                <td class="width-140 font-weight-bold">
                  第1希望
                  <span class="badge bg-danger text-white badge-required ml-1">※必須</span>
                </td>
                <td class="border-right-0 border-bottom-0">
                  <!-- <input type="text" maxlength="50" v-model="firstChoice"> -->
                  <select
                      class="requestPattern"
                      v-model="firstChoice"
                  >
                    <option v-for="data in requestPattern"
                            :key="data.code"
                            :value="data.code_name">
                            {{ data.code_name }}
                    </option>
                  </select>
                </td>
                <td rowspan="3" class="border-left-0" style="width: 500px;">
                  <!-- 例) ・8時台で<br>
                  ・スタート時間が連続すように<br>
                  ・午前のスタート<br>
                  ・何時でも可<br> -->
                </td>
              </tr>
              <tr>
                <td class="width-140">
                  第2希望
                </td>
                <td class="border-top-0 border-right-0 border-bottom-0">
                  <!-- <input type="text" maxlength="50" v-model="secondChoice"> -->
                  <select
                      class="requestPattern"
                      v-model="secondChoice"
                  >
                    <option v-for="data in requestPattern"
                            :key="data.code"
                            :value="data.code_name">
                            {{ data.code_name }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td class="width-140">
                  第3希望
                </td>
                <td class="border-right-0 border-top-0">
                  <!-- <input type="text" maxlength="50" v-model="thirdChoice"> -->
                  <select
                      class="requestPattern"
                      v-model="thirdChoice"
                  >
                    <option v-for="data in requestPattern"
                            :key="data.code"
                            :value="data.code_name">
                            {{ data.code_name }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td colspan="2" >
                  組数/人数
                  <span class="badge bg-danger text-white badge-required ml-1">※必須</span>
                </td>
                <td class="border-right-0">
                  <input type="text" style='width: 50px;' maxlength="3" v-model="numberSets" @blur="CheckInputData" @input="CheckInputData">組
                  <span class='px-4'>/</span>
                  <input type="text" style='width: 50px;' maxlength="4" v-model="numberPeople" @blur="CheckInputData" @input="CheckInputData">人
                </td>
                <td class="border-left-0">
                  <span v-if="valid" class="text-danger">{{ validMessage }}</span>
                </td>
              </tr>
            </table>
          </div>
          <div class='table-back-ground spview'>
            <div class="px-1 py-3 border-bottom">
                <div colspan="2" >
                    プレー日
                </div>
                <div>
                    {{ playDate }}
                </div>
            </div>
            <div class="px-1 py-3">
                <div >
                    スタート時間
                </div>
                <div>
                    <label for="first" class="mr-4 font-weight-bold">
                        第1希望
                        <span class="badge bg-danger text-white badge-required ml-2">※必須</span>
                    </label>
                    <!-- <input id="first" class="form-control" type="text" maxlength="50" v-model="firstChoice"> -->
                    <select
                        class="form-control"
                        v-model="firstChoice"
                    >
                        <option v-for="data in requestPattern"
                                :key="data.code"
                                :value="data.code_name">
                                {{ data.code_name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="px-1 py-3">
                <div>
                    <label for="second" class="mr-4">第2希望</label>
                    <!-- <input id="second" class="form-control" type="text" maxlength="50" v-model="secondChoice"> -->
                    <select
                        class="form-control"
                        v-model="secondChoice"
                    >
                        <option v-for="data in requestPattern"
                                :key="data.code"
                                :value="data.code_name">
                                {{ data.code_name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="px-1 py-3 border-bottom">
                <div class="pb-2">
                    <label for="third" class="mr-4">第3希望</label>
                    <!-- <input id="third" class="form-control" type="text" maxlength="50" v-model="thirdChoice"> -->
                    <select
                        class="form-control"
                        v-model="thirdChoice"
                    >
                        <option v-for="data in requestPattern"
                                :key="data.code"
                                :value="data.code_name">
                                {{ data.code_name }}
                        </option>
                    </select>
                </div>
                <!-- <div>
                    例) ・8時台で<br>
                    ・スタート時間が連続すように<br>
                    ・午前のスタート<br>
                    ・何時でも可<br>
                </div> -->
            </div>
            <div class="px-1 py-3 border-bottom">
                <div>
                    <label for="group" class="mr-4 font-weight-bold">組数/人数<span class="badge bg-danger text-white badge-required ml-2">※必須</span></label>
                </div>
                <div>
                    <input id="group" type="text" style='width: 50px;' maxlength="3" v-model="numberSets" @blur="CheckInputData" @input="CheckInputData">組
                    <span class='px-4'>/</span>
                    <input type="text" style='width: 50px;' maxlength="4" v-model="numberPeople" @blur="CheckInputData" @input="CheckInputData">人
                </div>
                <div>
                    <span v-if="valid" style='color: red;'>{{ validMessage }}</span>
                </div>
            </div>
          </div>
          <h4 class='font-weight-bold mt-4 bg-single'>ゴルフ場への連絡事項</h4>
          <div class="bg-single">ゴルフ場への連絡事項がある場合は、下記をご記入ください。</div>
          <div class='table-back-ground'>
            <table class="plan-info-display-table">
              <tr class="lastColumn contactForm">
                <td  valign="center">
                  連絡事項
                </td>
                <td valign="top">
                  <textarea class='textareas' placeholder="任意の入力" v-model="requestContactInfo"></textarea>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div>
          <h4 class='font-weight-bold bg-single mt-4'>
            プラン詳細
          </h4>
          <div class='table-back-ground'>
            <table class="plan-info-display-table">
              <tr>
                <td >プラン名</td>
                <td>{{ planName }}</td>
              </tr>
              <tr>
                <td >ゴルフ場名</td>
                <td>{{ golfName }}</td>
              </tr>
              <tr>
                <td >プレー日</td>
                <td>{{ playDate }}</td>
              </tr>
              <tr>
                <td >プレースタイル</td>
                <td>
                  <span v-for="icon in iconFlag" :key="icon.id">
                    <div class="play-style-icon" :class="icon.class"></div>
                  </span>
                </td>
              </tr>
              <tr class="lastColumn">
                <td valign="top">プラン詳細</td>
                <td valign="top">
                  <div style="overflow: auto; max-height:300px; max-width:850px; white-space: pre-line;">
                    {{ planDetailedSentence }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div>
          <h4 class='mt-3 font-weight-bold bg-single'>
            料金
          </h4>
          <div class='table-back-ground'>
            <table class="plan-info-display-table">
              <tr>
                <td >お一人様</td>
                <td colspan="2">
                  <span class="total-amount">￥{{ totalPrice }}</span>
                  <span>(総額)</span>
                </td>
              </tr>
              <tr>
                <td>３バッグ割増</td>
                <td class="extra-charge">{{ formatedSumUpFee[1] }}</td>
              </tr>
              <tr>
                <td>２バッグ割増</td>
                <td class="extra-charge">{{ formatedSumUpFee[0] }}</td>
              </tr>
              <tr class="lastColumn">
                <td  valign="top">キャンセル</td>
                <td colspan="2" valign="top" >
                  <div style="overflow: auto; max-height:300px; max-width:850px;">
                    {{ cancelSentence }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="d-flex py-3 justify-content-around flex-column flex-sm-row">
          <div style="flex-grow: .6;"></div>
          <div class="btn nextBtn mb-3" @click='onNext'>次　へ</div>
          <div style="flex-grow: .5;"></div>
          <div class="btn backBtn mb-3" @click='onBack'>戻る</div>
        </div>
      </div>
      <ErrorWordingDialogModal v-show="showError" v-bind:errorWording="errorMessage" v-on:closeErrorDialog="CloseErrorDialog"></ErrorWordingDialogModal>
    </div>
</template>

<script>
import ReserveHeader from './ReserveHeader';
import validater from "../../lib/validater";
import ErrorWordingDialogModal from '../components/ErrorDialog';
import { CODE_MASTER } from '../../config';
import { MEMBER_LOG_OUT } from "../../constants/signout";
import { GET_MEMBER_ID, RESERVE_LOGIN_AT_LINE } from '../../constants/signin';
import { GET_REQUEST_INITIALIZED_DATA } from '../../constants/plan_master';
import { utilityMixin } from '../../mixins/utility';
import { createApollo } from '../../lib/apollo';

export default {
    components: {
      ReserveHeader,
      ErrorWordingDialogModal
    },
    mixins: [
        utilityMixin
    ],
    data () {
        return {
            // ゴルフコード
            golfCode: null,
            // 予約種別
            reserveType: null,
            // エラーダイアログ表示フラグ
            showError: false,
            // エラーダイアログの文言
            errorMessage: null,
            // 希望１~３
            requestPattern: [],
            firstChoice: null,
            secondChoice: null,
            thirdChoice: null,
            // 組数
            numberSets: null,
            // 人数
            numberPeople: null,
            // 連絡事項
            requestContactInfo: null,
            // プランID
            planId: null,
            // ログイン状態
            loginState: false,
            // プラン名
            planName: null,
            // ゴルフ場名
            golfName: null,
            // 総額
            totalPrice: null,
            // プレー日
            playDate: null,
            // キャンセルポリシー
            cancelSentence: null,
            // プラン詳細
            planDetailedSentence: null,
            // プレースタイルアイコン
            iconFlag: [],
            // codeList: null,
            // バリデーションチェックメッセージ
            validMessage: "",
            // バリデーションチェック状態
            valid: false,
            // コース料金オブジェクト
            course_detail_fee: {
              sum_up_fee: {
                two:'0',
                three: '0',
                four: '0'
              },
            },
            fullName: 'ゲスト さん  ',
            // price4bHoliday: '割増無し',
            // price4bWeekday: '割増無し',
            // price3bHoliday: null,
            // price3bWeekday: null,
            // price2bHoliday: null,
            // price2bWeekday: null,
            memberNo: '',
            reserveData: {},
            loadingCount: 0,
            showReturnBtn: false,
            existImg: false,
            imgPath: ''
        };
    },
    created () {
        this.initialize();
    },
    computed: {
        formatedSumUpFee () {
            return Object.values(this.course_detail_fee.sum_up_fee).map(el => el === '0' ? '割増なし' : `￥${el}（消費税込）`);
        }
    },
    methods: {
        async initialize () {
            this.loadingCount = 0;
            this.$store.commit("loading/setIsLoading", true);

            if (this.$route.query.code) {
                // LINEログイン画面から遷移した場合（ログイン画面から遷移した場合は初期状態とする）
                let url =
                    process.env.MIX_GRAPHQL_URI +
                    "graphql?code=" +
                    this.$route.query.code;
                const client = createApollo(url);
                localStorage.removeItem("web-token");

                this.$store.commit("loading/setIsLoading", true);

                await client
                    .query({
                        query: RESERVE_LOGIN_AT_LINE,
                        fetchPolicy: "no-cache",
                        variables: {
                            providerName: "line",
                            redirectName: "services.line.redirect_request",
                            golfCode: ""
                        }
                    })
                    .then(res => {
                        localStorage.setItem("web-token", res.data.reserveLoginUsingSocial.accessToken);
                        if (localStorage.getItem("line-link")) {
                            this.$router.push("/" + localStorage.getItem("line-link") + "?access_from_line=1");
                            localStorage.removeItem("line-link");
                        } else {
                            this.$router.push("/requesttimeselect");
                        }
                    })
                    .catch(error => {
                        this.line_login_err_msg_txt = this.$t("error.validation.lineLoginError");
                        this.line_login_error = true;
                        this.$store.commit("loading/setIsLoading", false);
                    });
                this.reserveData = JSON.parse(localStorage.getItem('Reserve.reserveData'));
                localStorage.removeItem("Reserve.reserveData");
                sessionStorage.removeItem('Reserve.prevUrl');
                localStorage.removeItem("Reserve.returnBackUrl");
            } else if (localStorage.getItem("Reserve.returnBackUrl")) {
                // ログイン画面から遷移した場合（ログイン画面から遷移した場合は初期状態とする）
                this.reserveData = JSON.parse(localStorage.getItem('Reserve.reserveData'));
                localStorage.removeItem("Reserve.reserveData");
                sessionStorage.removeItem('Reserve.prevUrl');
                localStorage.removeItem("Reserve.returnBackUrl");
            } else {
                this.reserveData = JSON.parse(sessionStorage.getItem('Reserve.reserveData'));
            }

            this.golfCode = this.reserveData.golfCode;
            this.reserveType = this.reserveData.calendarReserveType;
            this.planId = this.reserveData.calendarPlanId;
            this.selectDate = new Date(this.reserveData.calendarSelectDate);
            this.playDate = this.getDateStrJapanese(this.selectDate) + '（' + this.getDayJapanese(this.selectDate) + '）';
            await this.GetRequestInitializedData(this.planId, this.selectDate);

            // ログイン状態を確認
            var token = localStorage.getItem('web-token');
            if (token) {
                // 会員番号を取得（取得できない場合はログアウト状態）
                if (await this.getLoginMember()) {
                    this.loginState = true;
                }
            }

        },
        /** ----------------------------------------------
         * プラン情報取得
         * @param planId プランID
         * @param targetDate プレー日
         * ---------------------------------------------- */
        GetRequestInitializedData: async function (planId, targetDate) {
            var targetDateStr = this.getDateStr(targetDate);
            this.loadingOn();
            try {
                this.$apollo.query({
                    query: GET_REQUEST_INITIALIZED_DATA,
                    variables: {
                        plan_id: planId,
                        play_date: targetDateStr
                    }
                }).then(res => {
                    this.setPlanDetail(
                        res.data.getRequestInitializedData.PlanCellInf,
                        res.data.getRequestInitializedData.AllSettingDays
                    );
                    this.requestPattern = res.data.getRequestInitializedData.CodeList;
                    if (res.data.getRequestInitializedData.golf_course_img_path) {
                        this.imgPath = res.data.getRequestInitializedData.golf_course_img_path;
                        this.existImg = true;
                    }
                    this.loadingOff();
                });
            } catch (error) {
                this.error = error;
                this.$store.commit("loading/setIsLoading", false);
            }
        },
        /** ----------------------------------------------
         * プランの詳細設定
         * @param planDetail プラン詳細
         * ---------------------------------------------- */
        setPlanDetail: function (planDetail, allSettingDay) {
            this.planName = planDetail.plan_name;
            this.golfName = planDetail.golf_name;
            this.totalPrice = planDetail.total_fee.toLocaleString();
            this.cancelSentence = planDetail.cancel_detail;
            this.planDetailedSentence = planDetail.detail;

            // 対象日が土日祝の場合
            if (this.judgeDay(new Date(this.selectDate), allSettingDay) > 0) {
                this.course_detail_fee['sum_up_fee']['two'] = planDetail.add_fee_2b_weekend.toLocaleString();
                this.course_detail_fee['sum_up_fee']['three'] = planDetail.add_fee_3b_weekend.toLocaleString();
                this.course_detail_fee['sum_up_fee']['four'] = "0";
            } else {
                this.course_detail_fee['sum_up_fee']['two'] = planDetail.add_fee_2b_weekday.toLocaleString();
                this.course_detail_fee['sum_up_fee']['three'] = planDetail.add_fee_3b_weekday.toLocaleString();
                this.course_detail_fee['sum_up_fee']['four'] = "0";
            }

            // プレースタイル設定
            this.iconFlag = [];
            if (planDetail.meal_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 1, class: planDetail.meal_flag_icon });
            }
            this.iconFlag.push({ id: 2, class: planDetail.cart_code_icon });

            this.iconFlag.push({ id: 3, class: planDetail.guarantee_code_icon });
            if (planDetail.caddie_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 4, class: planDetail.caddie_flag_icon });
            }
            this.iconFlag.push({ id: 5, class: planDetail.round_code_icon });
            if (planDetail.accommodation_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 6, class: planDetail.accommodation_flag_icon });
            }
            this.iconFlag.push({ id: 7, class: planDetail.share_flag_icon });
        },
        /** ----------------------------------------------
         * バリデーションチェック
         * ---------------------------------------------- */
        CheckInputData () {
            this.validMessage = "";
            this.valid = false;
            // メールアドレス形式
            if (this.numberSets) {
                if (!validater.checkIntType(this.numberSets)) {
                    this.validMessage = "※半角数字を入力してください。";
                    this.valid = true;
                }
                // 組数に0を入力されていた場合
                if (this.numberSets === '0') {
                    this.validMessage = "※組数には１以上を入力してください。";
                    this.valid = true;
                }
            }
            if (this.numberPeople) {
                if (!validater.checkIntType(this.numberPeople)) {
                    this.validMessage = "※半角数字を入力してください。";
                    this.valid = true;
                }
                // 人数に'0'を入力されていた場合
                if (this.numberPeople === '0') {
                    this.validMessage = "※人数には１以上を入力してください。";
                    this.valid = true;
                }
            }
            if (this.numberPeople) {
                if (validater.checkIntType(this.numberSets) && validater.checkIntType(this.numberPeople)) {
                    if (this.numberPeople > this.numberSets * 4) {
                        this.validMessage = "※人数が上限を超えています。";
                        this.valid = true;
                    }
                }
            }
        },
        /** ----------------------------------------------
         * エラーダイアログを閉じる
         * ---------------------------------------------- */
        CloseErrorDialog () {
            this.showError = false;
        },
        /** ----------------------------------------------
         * 戻るボタンの処理
         * ---------------------------------------------- */
        onBack() {
            if (sessionStorage.getItem('Reserve.prevUrl') === '/starttime') {
              sessionStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
              this.$router.push("/starttime");
              return;
            }
            sessionStorage.setItem('Reserve.prevUrl', "/reserve");
            sessionStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
            this.$router.push("/reserve");
        },
        /** ----------------------------------------------
         * 予約確認画面へ
         * ---------------------------------------------- */
        onNext() {
            if ( this.numberSets == null ||
                        this.numberSets.length == 0 ||
                        this.numberPeople == null ||
                        this.numberPeople.length == 0 ) {
                this.showError = true;
                this.errorMessage = '組数/人数に入力がございません。';
                this.valid = true;
                this.validMessage = '※入力してください';
            } else if (this.valid == true) {
                this.showError = true;
                this.errorMessage = '組数/人数の入力に不備があります。';
            } else if (this.checkStringLength(this.firstChoice)) {
                this.showError = true;
                this.errorMessage = '第1希望に入力がございません。';
            } else {
                // ログインしていない場合のログイン画面からの遷移URL（確認画面）をセット
                localStorage.setItem("Reserve.returnBackUrl", "/reservecontent");
                // ログインしていない場合があるためlocalStorageに設定
                this.reserveData['firstChoice'] = this.firstChoice;
                this.reserveData['secondChoice'] = this.secondChoice;
                this.reserveData['thirdChoice'] = this.thirdChoice;
                this.reserveData['cellNumber'] = this.numberSets;
                this.reserveData['playNumber'] = this.numberPeople;
                this.reserveData['contactInfo'] = this.requestContactInfo;
                localStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
                this.$store.commit('auth/setLineOperationTypeFlag', 'request');
                // 未ログイン時はここでログイン画面へ遷移
                if (this.loginState == false) {
                    this.$router.push('/?gc=' + localStorage.getItem('Reserve.golfCode'));
                } else {
                  // 確認画面表示
                  this.$router.push("/reservecontent");
                }
            }
        },
        /** ----------------------------------------------
         * 会員番号処理
         * ---------------------------------------------- */
        async getLoginMember() {
            let res = await this.$apollo
                .query({
                    query: GET_MEMBER_ID,
                    fetchPolicy: 'no-cache'
                })
                .catch(error => {
                    this.error = error;
                });
            if (res) {
                this.memberNo = res.data.getLoginMember.member_no;
                this.fullName = res.data.getLoginMember.family_name + ' ' + res.data.getLoginMember.given_name + ' さん ';
            } else {
                return false;
            }

            return true;
        },
        /** ----------------------------------------------
         * コードマスタを取得
         * ---------------------------------------------- */
        getCodeList (codeKey) {
            return this.$apollo.query({
                query: GET_CODE_LIST,
                variables: {
                    code_key: codeKey,
                    default_display: 0
                }
            }).then(res => {
                const data = res.data.GetCodeList.CodeList;
                return data;
            });
        },
        /** ----------------------------------------------
         * ログイン画面表示処理
         * ---------------------------------------------- */
        onLogin () {
            // localStorageに一時退避
            localStorage.setItem("Reserve.returnBackUrl", "/requesttimeselect");
            localStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
            localStorage.setItem("Reserve.logInUrl", "/requesttimeselect");
            this.$store.commit('auth/setLineOperationTypeFlag', 'request');
            this.$router.push('/?gc=' + localStorage.getItem('Reserve.golfCode'));
        },
        /** ----------------------------------------------
         * 会員登録画面表示処理
         * ---------------------------------------------- */
        onSignup () {
            // localStorageに一時退避
            localStorage.setItem("Reserve.returnBackUrl", "/requesttimeselect");
            localStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
            localStorage.setItem("Reserve.logInUrl", "/requesttimeselect");
            this.$store.commit('auth/setLineOperationTypeFlag', 'request');
            this.$router.push('/signup?gc=' + localStorage.getItem('Reserve.golfCode'));
        },
        /** ----------------------------------------------
         * ログオフ処理
         * ---------------------------------------------- */
        onLogout () {
            this.$store.commit("loading/setIsLoading", true);

            this.$store.commit("mypage/useGolfCode", null);
            this.$apollo.mutate({
                mutation: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.loginState = false;
                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
            this.fullName = 'ゲスト さん  ';
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function () {
            this.loadingCount++;
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function () {
            this.loadingCount--;
            if (this.loadingCount <= 0) {
                this.$store.commit("loading/setIsLoading", false);
            }
        },

        /** ----------------------------------------------
         * 子コンポーネントの処理終了通知
         * @param {Boolean} status true:正常  false:異常
         * ---------------------------------------------- */
        onFinishedProc: function (status) {
            if (status) {
                this.loadingOff();
            } else {
                this.$store.commit("loading/setIsLoading", false);
            }
        },

         /** ----------------------------------------------
         * 入力チェック
         * @param {String} text
         * ---------------------------------------------- */
        checkStringLength: function (text) {
            if (text) {
                if (text.trim().length >= 1) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }
    }
}

</script>

<style scoped>
table {
  width: 100%;
}
th{
  border: solid 1px #e8e8e8;
}
td{
  border: solid 1px #e8e8e8;
}
.btnWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
@media screen and (max-width: 575px) {
    .width-140{
      width: initial;
    }
    .contactForm td{
      border: none;
    }
}
</style>
